"use client";
import { Toaster } from "@/components/ui/toaster";
import { NuqsAdapter } from "nuqs/adapters/next/app";

import { TRPCReactProvider } from "@/trpc/react";
import type { Session } from "next-auth";
import { SessionProvider } from "next-auth/react";
import { AxiomWebVitals } from "next-axiom";
import { Toaster as SonnerToaster } from "sonner";

import { TooltipProvider } from "@/components/ui/tooltip";
import dynamic from "next/dynamic";

const ConfirmDialogProvider = dynamic(() =>
  import("@/components/providers/ConfirmProvider").then(
    (mod) => mod.ConfirmDialogProvider,
  ),
);

const PosthogAnalyticsProvider = dynamic(
  () =>
    import("../components/providers/PosthogAnalyticsProvider").then(
      (mod) => mod.PosthogAnalyticsProvider,
    ),
  { ssr: false },
);

export default function Providers({
  children,
  session,
}: {
  children: React.ReactNode;
  session: Session | null;
}) {
  return (
    <TooltipProvider delayDuration={0}>
      <SessionProvider session={session}>
        <PosthogAnalyticsProvider>
          <ConfirmDialogProvider>
            <NuqsAdapter>
              <AxiomWebVitals />
              {/* Onboarding provider should probably be in a layout further down the tree  where below requires the user to be onboarded*/}
              {/* <OnboardingProvider> */}
              <TRPCReactProvider>{children}</TRPCReactProvider>
              {/* </OnboardingProvider> */}
            </NuqsAdapter>
          </ConfirmDialogProvider>
        </PosthogAnalyticsProvider>
        <Toaster />
        <SonnerToaster />
      </SessionProvider>
    </TooltipProvider>
  );
}
